import { Card } from "design-system/molecules/Card"
import { MetricCard } from "design-system/organisms/insights/MetricCard"
import { useTranslation } from "react-i18next"
import { BackofficeCapabilityExecutionsAnalyticsResponseDataSchema } from "schema"
import { z } from "zod"

type Metrics = z.infer<
  typeof BackofficeCapabilityExecutionsAnalyticsResponseDataSchema
>["selectedCapabilityMetrics"]

type Props = {
  metrics: Metrics
  isPending: boolean
}

export function SelectedCapabilityMetrics({ metrics, isPending }: Props) {
  const { t } = useTranslation()
  const turnsToSuccess = metrics?.turnsToSuccess
  const successRate = metrics?.successRate ?? 0

  return (
    <Card className="p-4">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-0.5">
          <span className="text-md font-medium">
            {t("backoffice.capabilityExecutions.selectedMetrics.title")}
          </span>
          <span className="text-sm text-muted-foreground">
            {t("backoffice.capabilityExecutions.selectedMetrics.description")}
          </span>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <MetricCard
            title={t("backoffice.capabilityExecutions.selectedMetrics.turnsToSuccess")}
            tooltip={t("backoffice.capabilityExecutions.selectedMetrics.turnsToSuccessTooltip")}
            currentValue={
              turnsToSuccess === null || turnsToSuccess === undefined
                ? "—"
                : turnsToSuccess.toFixed(1)
            }
            metric={t("backoffice.capabilityExecutions.selectedMetrics.turnsToSuccessDetail")}
            isPending={isPending}
          />
          <MetricCard
            title={t("backoffice.capabilityExecutions.selectedMetrics.successRate")}
            tooltip={t("backoffice.capabilityExecutions.selectedMetrics.successRateTooltip")}
            currentValue={`${Math.round(successRate * 100)}%`}
            metric={t("backoffice.capabilityExecutions.selectedMetrics.successRateDetail", {
              successful: metrics?.successfulConversations ?? 0,
              total: metrics?.totalConversations ?? 0,
            })}
            isPending={isPending}
          />
        </div>
      </div>
    </Card>
  )
}
